export const fr = {
  nav: {
    home: 'Accueil',
    services: 'Services',
    about: 'À Propos',
    gallery: 'Galerie',
    contact: 'Contact',
    faq: 'FAQ',
    signIn: 'Connexion',
    signOut: 'Déconnexion',
    myAccount: 'Mon Compte',
    admin: 'Admin',
    bookNow: 'Réserver',
    privacy: 'Confidentialité',
    terms: 'Conditions'
  },
  
  business: {
    name: 'Mécanique Auto CJPA',
    tagline: 'Service Automobile Premium',
    address: '10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada',
    phone: '+1 514-327-2107',
    phone2: '+1 514-582-7527',
    email: 'info@mecanique-cjpa.com',
    hours: {
      title: 'Heures d\'Ouverture',
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
      weekdaysTime: '9h00 – 18h00',
      saturdayTime: 'Fermé',
      sundayTime: 'Fermé',
      closed: 'Fermé'
    }
  },
  
  home: {
    hero: {
      subtitle: 'Service Automobile Premium',
      title: 'Mécanique Auto CJPA',
      description: 'Où la précision rencontre la passion. Soins exceptionnels pour véhicules exceptionnels.',
      bookButton: 'Prendre Rendez-vous',
      servicesButton: 'Nos Services'
    },
    stats: {
      years: '15+',
      yearsLabel: 'Ans d\'Expérience',
      vehicles: '8 000+',
      vehiclesLabel: 'Véhicules Entretenus',
      satisfaction: '98%',
      satisfactionLabel: 'Satisfaction Client',
      technicians: '12',
      techniciansLabel: 'Techniciens Experts'
    },
    services: {
      subtitle: 'Ce Que Nous Offrons',
      title: 'Nos',
      titleHighlight: 'Services',
      viewAll: 'Voir Tous les Services →',
      from: 'À partir de',
      min: 'min'
    },
    whyChoose: {
      subtitle: 'La Norme CJPA',
      title: 'Précision.',
      titleHighlight: 'Excellence.',
      titleEnd: 'Confiance.',
      description: 'Chez Mécanique Auto CJPA, nous croyons que votre véhicule mérite la même attention méticuleuse aux détails qui a été mise dans sa fabrication. Nos techniciens certifiés apportent des décennies d\'expertise à chaque service, utilisant uniquement des pièces de qualité supérieure et les dernières technologies de diagnostic.',
      button: 'Planifier un Service',
      certified: {
        title: 'Excellence Certifiée',
        desc: 'Techniciens certifiés ASE avec formation spécifique aux fabricants pour toutes les grandes marques et modèles.'
      },
      pricing: {
        title: 'Tarification Transparente',
        desc: 'Aucune surprise. Estimations détaillées fournies avant tout travail, avec votre approbation complète requise.'
      },
      parts: {
        title: 'Pièces Authentiques',
        desc: 'Pièces OEM et après-marché premium, soutenues par des garanties complètes pour votre tranquillité d\'esprit.'
      },
      inspection: {
        title: 'Inspection Gratuite',
        desc: 'Chaque service comprend un rapport d\'inspection multipoint complet sans frais supplémentaires.'
      }
    },
    reviews: {
      subtitle: 'Ce Que Disent Nos Clients',
      title: 'Avis',
      titleHighlight: 'Clients',
      rating: '4,9 Note Google',
      viewAll: 'Voir Tous les Avis Google',
      reviews: 'avis'
    },
    cta: {
      subtitle: 'Prêt à Commencer?',
      title: 'Réservez Votre',
      titleHighlight: 'Rendez-vous',
      description: 'Découvrez le service automobile à son meilleur. Notre équipe est prête à prendre soin de votre véhicule avec l\'attention qu\'il mérite.',
      button: 'Réserver Maintenant'
    }
  },

  services: {
    title: 'Nos',
    titleHighlight: 'Services',
    subtitle: 'Soins Experts',
    description: 'De l\'entretien de routine aux réparations complexes, chaque service est effectué avec une précision méticuleuse par nos techniciens certifiés.',
    allCategory: 'Tous',
    bookButton: 'Réserver',
    callForPricing: 'Appelez pour tarifs',
    estimated: 'Estimé',
    minutes: 'minutes',
    dontSee: 'Vous ne voyez pas le service dont vous avez besoin? Contactez-nous — nous gérons une large gamme de réparations et d\'entretien automobile.',
    scheduleButton: 'Planifier Votre Service',
    from: 'À partir de'
  },

  booking: {
    title: 'Prendre',
    titleHighlight: 'Rendez-vous',
    subtitle: 'Réservez Votre Visite',
    steps: {
      service: 'Service',
      schedule: 'Horaire',
      vehicle: 'Véhicule',
      review: 'Réviser'
    },
    selectService: 'Sélectionner les Services',
    selectMultipleHint: 'Sélectionnez un ou plusieurs services pour votre rendez-vous',
    servicesSelected: 'service(s) sélectionné(s)',
    totalDuration: 'Durée totale',
    totalPrice: 'Prix total',
    totalLabel: 'Total',
    maxServices: 'Maximum 6 services par rendez-vous',
    chooseDatetime: 'Choisir Date et Heure',
    yourVehicle: 'Votre Véhicule',
    reviewConfirm: 'Réviser et Confirmer',
    
    dateLabel: 'Date Préférée',
    timeLabel: 'Heures Disponibles',
    notesLabel: 'Notes Supplémentaires (Optionnel)',
    notesPlaceholder: 'Décrivez tout problème ou demande spéciale...',
    
    useSaved: 'Utiliser Véhicule Enregistré',
    addNew: 'Ajouter Nouveau Véhicule',
    selectVehicle: 'Sélectionner Véhicule',
    addDifferent: '+ Ajouter un Autre Véhicule',
    
    makeLabel: 'Marque',
    makePlaceholder: 'Sélectionner Marque',
    modelLabel: 'Modèle',
    modelPlaceholder: 'Sélectionner Modèle',
    specifyModel: 'Spécifier Modèle',
    specifyPlaceholder: 'Entrez le modèle de votre véhicule',
    yearLabel: 'Année',
    plateLabel: 'Plaque (Optionnel)',
    platePlaceholder: 'ABC-1234',
    searchMake: 'Rechercher la marque...',
    searchModel: 'Rechercher le modèle...',
    otherMake: 'Autre (non listé)',
    otherModel: 'Autre (non listé)',
    popularMakes: 'Marques populaires',
    allMakes: 'Toutes les marques',
    noMakesFound: 'Aucune marque trouvée',
    noModelsFound: 'Aucun modèle trouvé',
    backToSearch: 'Retour à la recherche',
    
    reviewLabels: {
      service: 'Service',
      datetime: 'Date et Heure',
      vehicle: 'Véhicule',
      client: 'Client',
      notes: 'Notes'
    },
    
    continueButton: 'Continuer →',
    backButton: '← Retour',
    confirmButton: 'Confirmer Rendez-vous',
    bookingButton: 'Réservation...',
    bookingError: 'Échec de la réservation. Veuillez réessayer.',
    noAvailableTimes: 'Aucun créneau disponible pour cette date. Veuillez sélectionner une autre date.',
    loadingTimes: 'Chargement des créneaux disponibles...',
    closedDayError: 'Ce jour est fermé. Veuillez sélectionner une autre date.',
    pastDateError: 'Vous ne pouvez pas sélectionner une date passée. Veuillez choisir aujourd\'hui ou une date future.',
    depositRequired: 'Un dépôt est requis pour confirmer ce rendez-vous.',
    depositAmount: 'Montant du dépôt',
    proceedToPayment: 'Procéder au Paiement',
    paymentProcessing: 'Traitement...',
    paymentSuccess: 'Paiement réussi! Votre rendez-vous est confirmé.',
    paymentCancelled: 'Paiement annulé. Vous pouvez réessayer ou contacter le garage.',
    paymentPending: 'En attente de paiement',
    at: 'à',

    success: {
      confirmed: 'Confirmé',
      title: 'Rendez-vous Réservé',
      message: 'Votre rendez-vous a été reçu. Nous confirmerons sous peu et vous enverrons un rappel. Merci d\'avoir choisi Mécanique Auto CJPA.',
      viewButton: 'Voir Mes Rendez-vous',
      depositPaid: 'Dépôt payé'
    }
  },

  dashboard: {
    welcome: 'Bon Retour',
    newAppt: '+ Nouveau Rendez-vous',
    upcoming: 'À Venir',
    completed: 'Terminés',
    total: 'Total',
    tabs: {
      upcoming: 'À Venir',
      completed: 'Terminés',
      past: 'Passés',
      cancelled: 'Annulés'
    },
    yourReview: 'Votre Avis',
    noAppts: 'Aucun rendez-vous trouvé',
    firstAppt: 'Réservez votre premier rendez-vous →',
    cancel: 'Annuler',
    reschedule: 'Reprogrammer',
    rescheduleTitle: 'Reprogrammer le Rendez-vous',
    rescheduleConfirm: 'Confirmer le Nouvel Horaire',
    rescheduleSuccess: 'Rendez-vous reprogrammé avec succès',
    cancelConfirm: 'Êtes-vous sûr de vouloir annuler ce rendez-vous?',
    cancelSuccess: 'Rendez-vous annulé avec succès',
    cutoffError: 'Impossible de modifier dans les {hours} heures précédant le rendez-vous',
    leaveReview: 'Laisser un Avis',
    reviewed: 'Évalué',
    confirmCancel: 'Êtes-vous sûr de vouloir annuler ce rendez-vous?',
    cancelError: 'Erreur lors de l\'annulation du rendez-vous',
    at: 'à',
    status: {
      pending: 'En Attente',
      confirmed: 'Confirmé',
      in_progress: 'En Cours',
      completed: 'Terminé',
      cancelled: 'Annulé'
    },
    account: {
      title: 'Informations du Compte',
      name: 'Nom',
      email: 'Courriel',
      phone: 'Téléphone',
      notProvided: 'Non fourni'
    },
    notifications: {
      title: 'Préférences de Notification',
      emailToggle: 'Notifications par courriel',
      smsToggle: 'Notifications SMS',
      smsVerifyHint: 'Vérifiez votre numéro de téléphone pour activer les notifications SMS',
      preferredLang: 'Langue préférée pour les notifications',
      save: 'Sauvegarder les Préférences',
      saving: 'Sauvegarde...',
      saved: 'Préférences sauvegardées avec succès',
      error: 'Échec de la sauvegarde des préférences',
      pushToggle: 'Notifications push',
      pushDenied: 'Push bloqué — activez dans les paramètres du navigateur',
      marketingToggle: 'Courriels marketing',
      marketingHint: 'Recevoir promotions et nouvelles de notre part'
    },
    calendar: {
      addToCalendar: 'Ajouter au Calendrier'
    },
    messages: {
      title: 'Mes Messages',
      empty: 'Aucun message',
      viewThread: 'Voir le Fil',
      hideThread: 'Masquer le Fil',
      replyPlaceholder: 'Tapez votre réponse...',
      sendReply: 'Envoyer la Réponse',
      sending: 'Envoi...',
      replyFailed: 'Échec de l\'envoi de la réponse',
      status: {
        new: 'Nouveau',
        read: 'Lu',
        responded: 'Répondu'
      },
      attachImages: 'Joindre des images',
      attachHint: 'Max 3 images, 5 Mo chacune'
    },
    sections: {
      appointments: 'Rendez-vous',
      messages: 'Messages',
      profile: 'Profil',
      settings: 'Paramètres'
    },
    profile: {
      title: 'Informations du Profil',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Adresse Courriel',
      phone: 'Numéro de Téléphone',
      phoneVerified: 'Téléphone vérifié',
      verifyPhone: 'Vérifier le Téléphone',
      save: 'Sauvegarder le Profil',
      saving: 'Sauvegarde...',
      saved: 'Profil mis à jour avec succès',
      error: 'Échec de la mise à jour du profil',
      emailInUse: 'Ce courriel est déjà utilisé',
      phone2: 'Téléphone secondaire',
      phone2Hint: 'Optionnel — vérifiez pour recevoir les SMS sur ce numéro aussi'
    },
    phoneBanner: {
      title: 'Vérifiez votre numéro de téléphone',
      message: 'Ajoutez et vérifiez votre numéro de téléphone pour recevoir des rappels SMS pour vos rendez-vous.',
      verify: 'Vérifier maintenant',
      dismiss: 'Pas maintenant',
      reminderSmall: 'Votre numéro de téléphone n\'est pas vérifié.',
      verifyLink: 'Vérifier maintenant'
    },
    pushBanner: {
      title: 'Activer les notifications push',
      message: 'Recevez des notifications instantanées sur les mises à jour de rendez-vous, les promotions et les rappels importants directement sur votre appareil.',
      enable: 'Activer maintenant',
      dismiss: 'Pas maintenant'
    },
    reviewModal: {
      title: 'Comment était votre service?',
      rating: 'Note',
      comment: 'Votre Avis (Optionnel)',
      placeholder: 'Partagez votre expérience avec nous...',
      submit: 'Soumettre l\'Avis',
      submitting: 'Envoi en cours...',
      cancel: 'Annuler',
      success: 'Merci pour votre avis!',
      error: 'Impossible de soumettre l\'avis. Veuillez réessayer.',
      googleReview: 'Laisser aussi un avis Google',
      done: 'Terminé'
    }
  },

  auth: {
    login: {
      title: 'Bon Retour',
      subtitle: 'Connectez-vous pour gérer vos rendez-vous',
      emailLabel: 'Adresse Courriel',
      passwordLabel: 'Mot de Passe',
      button: 'Se Connecter',
      signing: 'Connexion...',
      noAccount: 'Nouveau client?',
      register: 'Créer un compte →',
      invalidCredentials: 'Identifiants invalides',
      forgotPassword: 'Mot de passe oublié?'
    },
    register: {
      title: 'Créer Votre Compte',
      subtitle: 'Rejoignez notre clientèle exclusive',
      firstNameLabel: 'Prénom',
      lastNameLabel: 'Nom',
      emailLabel: 'Adresse Courriel',
      confirmEmailLabel: 'Confirmer Courriel',
      phoneLabel: 'Numéro de Téléphone',
      passwordLabel: 'Mot de Passe',
      confirmLabel: 'Confirmer Mot de Passe',
      button: 'Créer un Compte',
      creating: 'Création du Compte...',
      hasAccount: 'Déjà client?',
      signIn: 'Se connecter →',
      emailMismatch: 'Les adresses courriel ne correspondent pas',
      passwordMismatch: 'Les mots de passe ne correspondent pas',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      registrationFailed: 'Échec de l\'inscription',
      invalidEmail: 'Veuillez entrer une adresse courriel valide',
      invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
      nameTooLong: 'Le nom doit contenir 50 caractères ou moins',
      consent: {
        transactionalTitle: 'Courriels liés à votre service (obligatoire)',
        transactionalDesc: 'Nous vous enverrons des courriels concernant vos rendez-vous, confirmations, mises à jour et informations de sécurité liées à votre compte.',
        marketingLabel: "J'accepte de recevoir des offres, promotions et conseils par courriel de la part de Mécanique Auto CJPA. Je peux retirer mon consentement à tout moment.",
        marketingHint: 'Le consentement marketing est optionnel et n\'affecte pas votre service.',
        privacyLink: 'Politique de confidentialité'
      }
    }
  },

  about: {
    title: 'À',
    titleHighlight: 'Propos',
    subtitle: 'Notre Histoire',
    mission: {
      title: 'Notre Mission',
      text: 'Chez Mécanique Auto CJPA, nous nous engageons à fournir un service automobile exceptionnel avec intégrité, expertise et dévouement. Depuis notre établissement, nous avons bâti une réputation de travail de qualité et de satisfaction client dans la communauté de Montréal-Nord.'
    },
    history: {
      title: 'Notre Histoire',
      paragraphs: [
        'Notre histoire a commencé le 31 mars 2016, portée par une vision commune et une confiance mutuelle. À l\'époque, nous travaillions ensemble dans le même garage de mécanique. Très vite, l\'idée de créer notre propre entreprise s\'est imposée comme une évidence.',
        'Nous voulions bâtir un garage à notre image\u00A0: intègre, rigoureux et axé sur la qualité du service. Un endroit où chaque client serait accueilli avec respect, transparence et professionnalisme.',
        'Dès le lendemain de cette décision, nous étions à la recherche d\'un local. Deux jours plus tard, le bail était signé. À ce moment-là, nous ne disposions que de deux coffres à outils et d\'un simple cric hydraulique — mais nous avions l\'essentiel\u00A0: l\'expérience, la détermination et la volonté de réussir.',
        'Une semaine plus tard, soit le 4 avril 2016, notre garage ouvrait officiellement ses portes.',
        'Ce projet, né d\'un simple échange, est devenu une entreprise fondée sur la passion du métier, le travail bien fait et la confiance de nos clients. Aujourd\'hui, nous sommes fiers du chemin parcouru et profondément reconnaissants envers celles et ceux qui nous permettent de continuer à évoluer et à grandir, jour après jour.'
      ]
    },
    team: {
      title: 'Notre Équipe',
      text: 'Notre équipe de techniciens certifiés ASE apporte des décennies d\'expérience combinée en réparation et entretien automobile. Nous investissons continuellement dans la formation et les équipements de diagnostic les plus récents pour garantir que nous pouvons entretenir toutes les marques et modèles avec précision et soin.'
    },
    values: {
      title: 'Nos Valeurs',
      quality: 'Qualité',
      qualityText: 'Nous ne faisons jamais de compromis sur la qualité de notre travail ou des pièces que nous utilisons. Votre sécurité et satisfaction sont nos priorités absolues.',
      transparency: 'Transparence',
      transparencyText: 'Communication claire et tarification honnête avec chaque service. Nous expliquons ce qui doit être fait et pourquoi.',
      expertise: 'Expertise',
      expertiseText: 'Formation continue pour rester à jour avec la technologie automobile en évolution et les spécifications des fabricants.',
      community: 'Communauté',
      communityText: 'Fiers de servir la communauté de Montréal-Nord avec excellence. Nous traitons chaque client comme un membre de la famille.'
    },
    visit: 'Visitez-nous Aujourd\'hui',
    visitText: 'Découvrez la différence CJPA. Notre installation est équipée d\'outils de diagnostic de pointe et notre équipe est prête à dépasser vos attentes.'
  },

  contact: {
    title: 'Nous',
    titleHighlight: 'Contacter',
    subtitle: 'Entrer en Contact',
    visitUs: 'Nous Visiter',
    callUs: 'Nous Appeler',
    emailUs: 'Nous Écrire',
    directions: 'Obtenir Itinéraire',
    form: {
      title: 'Envoyez-nous un Message',
      nameLabel: 'Votre Nom',
      emailLabel: 'Votre Courriel',
      phoneLabel: 'Numéro de Téléphone',
      subjectLabel: 'Sujet',
      messageLabel: 'Message',
      messagePlaceholder: 'Comment pouvons-nous vous aider?',
      send: 'Envoyer Message',
      sending: 'Envoi...',
      success: 'Message envoyé! Nous vous répondrons bientôt.',
      error: 'Impossible d\'envoyer le message. Veuillez réessayer ou nous appeler directement.',
      loginRequired: 'Veuillez vous connecter pour nous envoyer un message.',
      loginButton: 'Se Connecter',
      messageTooShort: 'Le message doit contenir au moins 5 caractères',
      messageTooLong: 'Le message doit contenir 2000 caractères ou moins',
      subjectTooLong: 'Le sujet doit contenir 200 caractères ou moins',
      charCount: 'caractères',
      attachImages: 'Joindre des images',
      attachHint: 'Max 3 images, 5 Mo chacune (JPEG, PNG, GIF, WebP)'
    }
  },

  faq: {
    title: 'Questions',
    titleHighlight: 'Fréquentes',
    subtitle: 'Questions Courantes',
    categories: {
      services: 'Services',
      booking: 'Réservation',
      pricing: 'Tarification',
      general: 'Général'
    }
  },

  gallery: {
    title: 'Notre',
    titleHighlight: 'Travail',
    subtitle: 'Galerie',
    description: 'Découvrez le travail de qualité que nous effectuons chaque jour. De l\'entretien de routine aux réparations complexes, nous sommes fiers de chaque travail.',
    images: [
      { title: 'Réparation moteur', desc: 'Diagnostic et réparation moteur complexe', src: '/images/gallery/engine-repair.jpg', altKey: 'gallery1' },
      { title: 'Service de freins', desc: 'Remplacement professionnel de plaquettes de frein', src: '/images/gallery/brake-service.jpg', altKey: 'gallery2' },
      { title: 'Changement d\'huile', desc: 'Service de changement d\'huile rapide et efficace', src: '/images/gallery/oil-change.jpg', altKey: 'gallery3' },
      { title: 'Travail de diagnostic', desc: 'Systèmes de diagnostic informatique avancés', src: '/images/gallery/diagnostic-scan.jpg', altKey: 'gallery4' },
      { title: 'Service de transmission', desc: 'Entretien expert de transmission', src: '/images/gallery/transmission-repair.jpg', altKey: 'gallery5' },
      { title: 'Alignement des roues', desc: 'Service d\'alignement de roues de précision', src: '/images/gallery/wheel-alignment.jpg', altKey: 'gallery6' }
    ],
    comingSoon: 'Photos à venir! Suivez-nous sur les réseaux sociaux pour voir nos derniers travaux.'
  },

  privacy: {
    title: 'Politique de',
    titleHighlight: 'Confidentialité',
    lastUpdated: 'Dernière mise à jour : Février 2026',
    intro: 'Chez Mécanique Auto CJPA, nous respectons votre vie privée et nous nous engageons à protéger vos renseignements personnels conformément à la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE) et à la Loi sur la protection des renseignements personnels dans le secteur privé du Québec (Loi 25). Cette politique explique comment nous collectons, utilisons, conservons et protégeons vos données.',
    sections: [
      ['Responsable de la protection des renseignements personnels', 'Conformément à la Loi 25 du Québec, Mécanique Auto CJPA a désigné un Responsable de la protection des renseignements personnels. Pour toute question, demande ou préoccupation concernant vos données personnelles, vous pouvez contacter notre Responsable à : info@mecanique-cjpa.com ou par téléphone au +1 514-327-2107 / +1 514-582-7527, ou par courrier au 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada.'],
      ['Lois applicables', 'Cette politique de confidentialité est régie par la Loi sur la protection des renseignements personnels dans le secteur privé du Québec (Loi 25), telle que modifiée, et par la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE) pour toute activité interprovinciale ou internationale. Nous nous engageons à respecter toutes les lois canadiennes et québécoises applicables en matière de protection de la vie privée.'],
      ['Renseignements que nous collectons', 'Nous collectons les renseignements personnels suivants lorsque vous utilisez notre site Web, prenez rendez-vous ou créez un compte : vos nom et prénom, adresse courriel, numéro de téléphone, informations sur votre véhicule (marque, modèle, année, plaque d\'immatriculation), détails des rendez-vous et historique de service, identifiants de compte (mot de passe chiffré), messages soumis via le formulaire de contact et préférences linguistiques. Ces renseignements sont collectés directement auprès de vous lorsque vous les fournissez volontairement via les formulaires de notre site Web.'],
      ['Fins de la collecte', 'Nous collectons et utilisons vos renseignements personnels aux fins spécifiques suivantes : traitement et gestion de vos rendez-vous; prestation de services de réparation et d\'entretien automobile; communication avec vous concernant vos rendez-vous, services et l\'état de votre véhicule; maintien de votre historique de service et de véhicule pour vos visites futures; réponse à vos demandes soumises via notre formulaire de contact; gestion de votre compte en ligne; mémorisation de votre préférence linguistique (français/anglais); amélioration de notre site Web et de nos services; et conformité aux obligations légales et réglementaires. Nous n\'utiliserons pas vos renseignements personnels à d\'autres fins que celles énoncées ci-dessus sans avoir préalablement obtenu votre consentement.'],
      ['Consentement', 'En créant un compte, en prenant rendez-vous ou en soumettant un formulaire de contact sur notre site Web, vous donnez votre consentement exprès à la collecte, l\'utilisation et le stockage de vos renseignements personnels aux fins décrites dans cette politique. Votre consentement est volontaire. Vous pouvez retirer votre consentement à tout moment en contactant notre Responsable de la protection des renseignements personnels. Veuillez noter que le retrait du consentement peut affecter notre capacité à fournir certains services, comme la gestion de vos rendez-vous ou le maintien de votre historique de service. Nous n\'utilisons pas de cases de consentement pré-cochées et vous informerons toujours clairement des données collectées et des raisons de leur collecte.'],
      ['Stockage et sécurité des données', 'Vos renseignements personnels sont stockés dans des bases de données chiffrées hébergées au Canada. Nous mettons en œuvre des mesures de sécurité conformes aux normes de l\'industrie pour protéger vos données, notamment : le chiffrement des données en transit et au repos, le hachage sécurisé des mots de passe (bcrypt), des contrôles d\'accès limitant l\'accès aux données au personnel autorisé uniquement, des révisions régulières de la sécurité de nos systèmes et une gestion sécurisée des sessions. Malgré nos meilleurs efforts, aucune méthode de stockage électronique n\'est sécurisée à 100%. Nous prenons toutes les précautions raisonnables pour protéger vos informations, mais ne pouvons garantir une sécurité absolue.'],
      ['Conservation des données', 'Nous conservons vos renseignements personnels uniquement aussi longtemps que nécessaire pour atteindre les fins pour lesquelles ils ont été collectés : les données de compte actif sont conservées pendant la durée de votre compte plus 3 ans après votre dernière activité; les dossiers de rendez-vous et de service sont conservés pendant 7 ans à des fins de garantie et juridiques; les messages du formulaire de contact sont conservés pendant 2 ans; les témoins de session expirent lorsque vous fermez votre navigateur; les témoins de préférence linguistique sont conservés jusqu\'à ce que vous effaciez les données de votre navigateur. Lorsque les renseignements personnels ne sont plus nécessaires, ils sont supprimés de manière sécurisée ou anonymisés.'],
      ['Témoins (Cookies) et technologies de suivi', 'Notre site Web utilise uniquement des témoins essentiels nécessaires au fonctionnement du site : des témoins de session pour maintenir votre état de connexion et un témoin de préférence linguistique pour mémoriser votre choix entre le français et l\'anglais. Nous n\'utilisons aucun témoin de suivi, témoin d\'analyse, témoin publicitaire ou technologie de suivi tierce. Aucun profilage ni suivi comportemental n\'est effectué. Vous pouvez configurer votre navigateur pour refuser les témoins, mais cela pourrait affecter le fonctionnement de certaines fonctionnalités comme le maintien de votre connexion.'],
      ['Fournisseurs de services tiers', 'Nous pouvons partager des renseignements personnels limités avec des fournisseurs de services tiers de confiance qui nous aident à exploiter notre entreprise, tels que des fournisseurs d\'hébergement Web et de services de courriel. Ces fournisseurs sont contractuellement tenus de protéger vos renseignements personnels et ne peuvent les utiliser que pour les services spécifiques pour lesquels nous les avons engagés. Vos renseignements personnels ne sont ni vendus, ni loués, ni échangés à des tiers à des fins de marketing ou à toute autre fin. Tous les fournisseurs de services utilisés sont basés au Canada ou sont liés par des protections de confidentialité équivalentes.'],
      ['Transferts de données transfrontaliers', 'Vos renseignements personnels sont principalement stockés et traités au Canada. Dans le cas où des renseignements personnels devraient être transférés à l\'extérieur du Québec ou du Canada, nous nous assurerons que des mesures de protection adéquates sont en place conformément à la Loi 25, et nous vous informerons et obtiendrons votre consentement avant tout transfert.'],
      ['Vos droits en vertu des lois canadiennes et québécoises', 'En vertu de la LPRPDE et de la Loi 25 du Québec, vous disposez des droits suivants concernant vos renseignements personnels : le droit d\'être informé sur la façon dont vos renseignements personnels sont collectés, utilisés et divulgués; le droit d\'accéder aux renseignements personnels que nous détenons à votre sujet; le droit de demander la correction de renseignements inexacts ou incomplets; le droit de demander la suppression ou l\'anonymisation de vos renseignements personnels; le droit à la portabilité des données — de recevoir vos informations dans un format structuré et couramment utilisé et de les faire transférer à une autre organisation; le droit de retirer votre consentement à tout moment; et le droit de déposer une plainte si vous estimez que vos droits à la vie privée ont été violés. Pour exercer l\'un de ces droits, veuillez contacter notre Responsable de la protection des renseignements personnels. Nous répondrons à votre demande dans un délai de 30 jours.'],
      ['Notification en cas d\'atteinte à la sécurité', 'En cas d\'atteinte à la sécurité impliquant vos renseignements personnels présentant un risque de préjudice sérieux, nous : aviserons la Commission d\'accès à l\'information du Québec (CAI) comme l\'exige la Loi 25; vous aviserons dans les meilleurs délais, en décrivant la nature de l\'atteinte, les renseignements concernés et les mesures que nous prenons; et tiendrons un registre de tous les incidents de sécurité. Nous maintenons des procédures pour détecter, enquêter et répondre aux atteintes à la sécurité de manière rapide.'],
      ['Vie privée des enfants', 'Nos services ne sont pas destinés aux enfants de moins de 14 ans. Nous ne collectons pas sciemment de renseignements personnels auprès d\'enfants de moins de 14 ans. Pour les mineurs de 14 à 17 ans, le consentement peut être donné par le mineur lui-même conformément au droit québécois. Si nous apprenons que nous avons collecté des informations d\'un enfant de moins de 14 ans sans le consentement parental, nous prendrons les mesures nécessaires pour supprimer ces informations rapidement.'],
      ['Prise de décision automatisée', 'Nous n\'utilisons pas de systèmes de prise de décision automatisée ni de profilage produisant des effets juridiques ou des effets similaires significatifs sur les individus. Toutes les décisions concernant vos services et rendez-vous sont prises par les membres de notre équipe.'],
      ['Modifications à cette politique', 'Nous pouvons mettre à jour cette politique de confidentialité de temps à autre pour refléter les changements dans nos pratiques, notre technologie ou les exigences légales. Tout changement important sera publié sur cette page avec une date d\'entrée en vigueur mise à jour. Nous vous encourageons à consulter cette politique périodiquement. L\'utilisation continue de nos services après la publication des modifications constitue une acceptation de la politique mise à jour.'],
      ['Déposer une plainte', 'Si vous estimez que vos droits à la vie privée ont été violés, vous pouvez déposer une plainte auprès de notre Responsable de la protection des renseignements personnels à info@mecanique-cjpa.com. Si vous n\'êtes pas satisfait de notre réponse, vous avez le droit de déposer une plainte auprès de : la Commission d\'accès à l\'information du Québec (CAI) — www.cai.gouv.qc.ca — l\'autorité réglementaire principale pour les questions de vie privée au Québec; ou le Commissariat à la protection de la vie privée du Canada (CPVP) — www.priv.gc.ca — pour les questions relevant de la LPRPDE.'],
      ['Nous contacter', 'Pour toute question, préoccupation ou demande concernant cette politique de confidentialité ou le traitement de vos renseignements personnels, veuillez nous contacter : Mécanique Auto CJPA, À l\'attention du : Responsable de la protection des renseignements personnels, 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada. Courriel : info@mecanique-cjpa.com. Téléphone : +1 514-327-2107 / +1 514-582-7527.']
    ]
  },

  terms: {
    title: 'Conditions',
    titleHighlight: 'd\'Utilisation',
    lastUpdated: 'Dernière mise à jour : Février 2026',
    intro: 'Les présentes Conditions d\'utilisation régissent votre utilisation du site Web de Mécanique Auto CJPA et de nos services de réparation et d\'entretien automobile. En utilisant notre site Web, en prenant rendez-vous ou en créant un compte, vous acceptez les présentes conditions. Ces conditions sont assujetties à la Loi sur la protection du consommateur du Québec, au Code civil du Québec et à toutes les lois canadiennes et québécoises applicables. En cas de divergence entre les versions française et anglaise des présentes conditions, la version française prévaudra conformément à la loi québécoise.',
    sections: [
      ['Informations sur le commerçant', 'Mécanique Auto CJPA, situé au 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada. Téléphone : +1 514-327-2107 / +1 514-582-7527. Courriel : info@mecanique-cjpa.com. Responsable de la protection des renseignements personnels : info@mecanique-cjpa.com.'],
      ['Services', 'Nous fournissons des services professionnels de réparation et d\'entretien automobile, incluant mais sans s\'y limiter : changements d\'huile, service de freins, diagnostics moteur, service de transmission, alignement des roues, rotation des pneus, remplacement de batterie, service de suspension et direction, et service de climatisation. Tous les services sont effectués par des techniciens certifiés ASE utilisant des pièces de qualité et de l\'équipement conforme aux normes de l\'industrie et aux spécifications des fabricants.'],
      ['Rendez-vous en ligne', 'Les rendez-vous peuvent être pris via notre site Web et sont soumis à la disponibilité. En prenant rendez-vous, vous faites une demande de service — la confirmation finale sera fournie par notre équipe. Nous nous réservons le droit de reprogrammer les rendez-vous si nécessaire en raison de circonstances imprévues et vous aviserons dès que possible. Les annulations doivent être faites au moins 24 heures à l\'avance. Aucuns frais d\'annulation ne sont facturés.'],
      ['Estimations et tarification', 'Conformément à la Loi sur la protection du consommateur du Québec, une estimation écrite sera fournie pour toute réparation devant dépasser 100 $. Nous ne procéderons à aucun travail dépassant l\'estimation de plus de 10 % sans votre autorisation préalable. Si des frais sont exigés pour la préparation d\'une estimation, vous en serez informé avant que l\'estimation ne soit préparée. Tous les prix affichés sur notre site Web sont en dollars canadiens (CAD) et incluent les informations pertinentes sur les fourchettes de prix. La tarification finale est déterminée après l\'inspection du véhicule et vous est communiquée pour approbation avant le début de tout travail. Nous honorons tous les prix annoncés conformément à la Loi sur la concurrence du Canada.'],
      ['Paiement', 'Le paiement est dû à la fin des services. Nous acceptons l\'argent comptant, toutes les cartes de crédit majeures et les cartes de débit. Tous les prix sont en dollars canadiens. Une facture détaillée sera fournie pour chaque service, incluant : la date de remise du véhicule, la lecture de l\'odomètre, la description des travaux effectués, le nom et l\'état de chaque pièce installée (neuve, usagée ou reconditionnée), le prix individuel de chaque pièce, le nombre d\'heures de main-d\'œuvre facturées, le taux horaire et le coût total.'],
      ['Garantie sur les réparations', 'Conformément à la Loi sur la protection du consommateur du Québec, toutes les réparations dépassant 50 $ sont garanties pour un minimum de 3 mois ou 5 000 kilomètres, selon la première éventualité. Cette garantie couvre les pièces et la main-d\'œuvre liées à la réparation originale. Si votre véhicule doit retourner à notre atelier pour le même problème pendant la période de garantie, la période de garantie est prolongée du nombre de jours pendant lesquels votre véhicule est en notre possession pour la réparation sous garantie. La garantie ne couvre pas les dommages résultant d\'une mauvaise utilisation, de la négligence, d\'accidents, de l\'usure normale ou de modifications effectuées par des tiers. Pour faire une réclamation sous garantie, contactez-nous avec votre facture originale et une description du problème.'],
      ['Pièces remplacées', 'Conformément à la loi québécoise, vous avez le droit de demander le retour de toute pièce qui a été remplacée lors d\'une réparation. Veuillez faire cette demande au moment du service. Si aucune demande n\'est faite, les pièces remplacées pourront être éliminées conformément aux règlements environnementaux.'],
      ['Obligations du client', 'En tant que client, vous vous engagez à : fournir des informations exactes et complètes sur votre véhicule (marque, modèle, année, problèmes connus); divulguer toute condition préexistante ou modification pouvant affecter le service; vous présenter à l\'heure prévue de votre rendez-vous ou nous aviser de tout retard; fournir une autorisation rapide pour tout travail dépassant l\'estimation originale; et récupérer votre véhicule dans un délai raisonnable après la fin du service.'],
      ['Nos obligations', 'Nous nous engageons à : effectuer tous les services avec prudence, diligence et conformément aux normes de l\'industrie et aux règles de notre métier tel que requis par le Code civil du Québec; utiliser des pièces de qualité appropriées pour votre véhicule; fournir une communication honnête et transparente sur les réparations nécessaires; fournir une facture détaillée pour tous les travaux effectués; et garantir notre travail conformément à la garantie décrite dans les présentes conditions.'],
      ['Limitation de responsabilité', 'Conformément au droit québécois, rien dans les présentes conditions ne limite ou n\'exclut notre responsabilité pour : la faute intentionnelle ou lourde de notre part ou de celle de nos employés; les préjudices corporels; ou toute responsabilité qui ne peut être exclue ou limitée en vertu de la Loi sur la protection du consommateur du Québec ou du Code civil du Québec. Nous ne sommes pas responsables des conditions préexistantes du véhicule non liées aux services que nous avons effectués, des dommages causés par l\'omission du client de divulguer des problèmes connus, de l\'usure normale, ou des problèmes découlant de modifications non autorisées aux travaux que nous avons effectués. Toute limitation de responsabilité dans les présentes conditions est assujettie à vos droits en vertu de la Loi sur la protection du consommateur du Québec et du Code civil du Québec et ne les remplace pas.'],
      ['Entreposage du véhicule', 'Pendant que votre véhicule est sous notre garde pour un service, nous maintenons une couverture d\'assurance appropriée et prenons des précautions raisonnables pour le protéger. Les véhicules doivent être récupérés dans les 48 heures suivant la fin du service, sauf arrangement contraire. Nous ne sommes pas responsables des effets personnels laissés dans le véhicule. Les véhicules laissés pendant une période prolongée sans communication peuvent être soumis à des frais d\'entreposage après qu\'un avis raisonnable ait été donné.'],
      ['Comptes utilisateurs', 'Lors de la création d\'un compte sur notre site Web, vous acceptez de fournir des informations exactes et de maintenir la confidentialité de vos identifiants de connexion. Vous êtes responsable de toute activité effectuée sous votre compte. Vous pouvez demander la suppression de votre compte à tout moment en nous contactant. Les données de compte sont traitées conformément à notre Politique de confidentialité et à la Loi 25 du Québec.'],
      ['Propriété intellectuelle', 'Tout le contenu de notre site Web, y compris les textes, le design, les logos et les images, est la propriété de Mécanique Auto CJPA et est protégé par la Loi sur le droit d\'auteur du Canada. Vous ne pouvez pas reproduire, distribuer ou utiliser notre contenu sans autorisation écrite. Le contenu généré par les utilisateurs tel que les avis reste votre propriété, mais vous nous accordez une licence non exclusive pour l\'afficher sur notre site Web.'],
      ['Protection des renseignements personnels', 'Vos renseignements personnels sont collectés, utilisés et protégés conformément à notre Politique de confidentialité, à la Loi 25 du Québec et à la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE). En utilisant nos services, vous consentez à la collecte et à l\'utilisation de vos renseignements personnels tel que décrit dans notre Politique de confidentialité. Vous avez le droit d\'accéder, de corriger, de supprimer et de transférer vos renseignements personnels comme détaillé dans notre Politique de confidentialité.'],
      ['Résolution des différends', 'Nous nous engageons à résoudre tout différend de manière équitable et rapide. Si vous avez une plainte, veuillez nous contacter directement à info@mecanique-cjpa.com ou au +1 514-327-2107 / +1 514-582-7527. Conformément à la Loi sur la protection du consommateur du Québec, les présentes conditions ne contiennent aucune clause d\'arbitrage obligatoire, et votre droit d\'intenter des procédures judiciaires devant les tribunaux est entièrement préservé. Vous conservez également le droit de participer à tout recours collectif. Si nous ne parvenons pas à résoudre votre plainte, vous pouvez déposer une plainte auprès de l\'Office de la protection du consommateur (OPC) à www.opc.gouv.qc.ca ou appeler le 1-888-OPC-ALLO (672-2556).'],
      ['Langue', 'Conformément à la Charte de la langue française du Québec, les présentes Conditions d\'utilisation sont disponibles en français et en anglais. La version française est la version officielle. En cas de divergence entre les versions française et anglaise, la version française prévaudra.'],
      ['Loi applicable', 'Les présentes conditions sont régies par et interprétées conformément aux lois de la province de Québec et aux lois applicables du Canada. Tout différend découlant des présentes conditions sera soumis à la compétence exclusive des tribunaux du Québec. Rien dans les présentes conditions ne limite vos droits en vertu de la Loi sur la protection du consommateur du Québec, du Code civil du Québec ou de toute autre législation applicable.'],
      ['Droits du consommateur', 'Les présentes Conditions d\'utilisation sont assujetties à vos droits en vertu de la Loi sur la protection du consommateur du Québec, du Code civil du Québec et de toute autre législation applicable en matière de protection du consommateur, et ne les remplacent pas. Nous vous encourageons à vous familiariser avec vos droits en tant que consommateur. Pour plus d\'informations, visitez l\'Office de la protection du consommateur à www.opc.gouv.qc.ca.'],
      ['Modifications des conditions', 'Nous pouvons mettre à jour les présentes Conditions d\'utilisation de temps à autre pour refléter les changements dans nos pratiques ou les exigences légales. Les changements importants seront publiés sur cette page avec une date d\'entrée en vigueur mise à jour. Nous vous encourageons à consulter ces conditions périodiquement. L\'utilisation continue de nos services après la publication des modifications constitue votre acceptation des conditions mises à jour, sous réserve de vos droits en vertu de la loi applicable.'],
      ['Nous contacter', 'Pour toute question, préoccupation ou plainte concernant les présentes Conditions d\'utilisation, veuillez nous contacter : Mécanique Auto CJPA, 10011 Av. de Rome, Montréal-Nord, QC H1H 4N3, Canada. Courriel : info@mecanique-cjpa.com. Téléphone : +1 514-327-2107 / +1 514-582-7527.']
    ]
  },

  footer: {
    description: 'Service automobile premium livré avec précision, expertise et un engagement inébranlable envers l\'excellence.',
    navigate: 'Navigation',
    services: 'Services',
    servicesList: ['Changement d\'Huile', 'Service de Freins', 'Diagnostic Moteur', 'Alignement des Roues', 'Transmission'],
    excellence: 'Excellence dans Chaque Détail',
    rights: '© 2024 Mécanique Auto CJPA. Tous droits réservés.'
  },

  admin: {
    title: 'Tableau de Bord',
    titleHighlight: 'Admin',
    welcome: 'Bon retour',
    stats: {
      todayAppts: 'Rendez-vous Aujourd\'hui',
      pending: 'En Attente',
      totalCustomers: 'Total Clients',
      avgRating: 'Note Moyenne',
      reviews: 'avis'
    },
    tabs: {
      overview: 'Aperçu',
      appointments: 'Rendez-vous',
      reviews: 'Avis',
      messages: 'Messages',
      customers: 'Clients',
      settings: 'Paramètres',
      services: 'Services',
      promotions: 'Promotions',
      campaigns: 'Campagnes',
      reminders: 'Rappels',
      reports: 'Rapports',
      import: 'Importer',
      marketing: 'Contenu Marketing'
    },
    reports: {
      // Contrôles de filtre
      startDate: 'Date de début',
      endDate: 'Date de fin',
      applyFilter: 'Appliquer',
      clearFilter: 'Effacer',
      filterFormLabel: 'Filtre de période du rapport',
      presetToday: "Aujourd'hui",
      preset7d: '7 derniers jours',
      presetMonth: 'Ce mois-ci',
      presetLastMonth: 'Mois dernier',
      presetQuarter: 'Ce trimestre',
      presetYtd: 'Depuis janvier',
      presetAll: 'Tout',
      // Indicateurs de performance
      summaryTitle: 'Rapport de revenus',
      completedAppointments: 'Complétés',
      confirmedRevenue: 'Revenus confirmés',
      netRevenue: 'Revenus nets',
      depositsCollected: 'Dépôts encaissés',
      deposits: 'dépôts',
      refundsIssued: 'Remboursements',
      estimatedLow: 'Est. minimum',
      estimatedHigh: 'Est. maximum',
      estimatedMid: 'Est. médiane',
      avgTicketConfirmed: 'Ticket moyen',
      completionRate: 'Taux de complétion',
      cancellationRate: "Taux d'annulation",
      avgLeadDays: 'Délai moyen',
      days: 'jours',
      repeatRate: 'Taux de fidélisation',
      customers: 'clients',
      zeroBanner: "Aucun revenu confirmé pour l'instant. Inscrivez les prix réels lors de la complétion des rendez-vous pour afficher les chiffres exacts ici.",
      // Graphiques
      revenueOverTime: 'Revenus dans le temps',
      topServices: 'Top 5 des services par revenus',
      statusDistribution: 'Répartition des statuts',
      // Tableau par service
      byService: 'Revenus par service',
      byServiceCaption: 'Répartition des revenus par type de service',
      service: 'Service',
      lineItems: 'Services',
      appointments: 'RDV',
      confirmed: 'Confirmé',
      avgPrice: 'Prix moy.',
      pctOfTotal: '% du total',
      sortBy: 'Trier',
      sort_revenue: 'Revenus',
      sort_count: 'Nombre',
      sort_name: 'Nom',
      // Tableau par mois
      byMonth: 'Revenus par mois',
      byMonthCaption: 'Répartition mensuelle des revenus',
      month: 'Mois',
      vsPrior: 'vs précédent',
      total: 'Total',
      // À venir
      upcomingRevenue: 'Revenus à venir (estimés)',
      upcomingAppointments: 'À venir',
      upcomingByServiceCaption: 'Revenus à venir par service',
      count: 'Nombre',
      estimatedRange: 'Fourchette est.',
      // Heures de pointe
      busiestTimes: 'Heures de pointe',
      busiestTimesCaption: 'Volume de rendez-vous par jour et heure',
      // Meilleurs clients
      topCustomersTitle: 'Top 10 des clients',
      topCustomersCaption: 'Meilleurs clients par revenus à vie',
      customer: 'Client',
      revenue: 'Revenus',
      lastVisit: 'Dernière visite',
      // Exportation
      exportCSV: 'Exporter CSV',
      exportPDF: 'Exporter PDF',
      // Véhicules
      topVehiclesTitle: 'Véhicules les plus servis',
      topVehiclesCaption: 'Marques et modèles les plus fréquemment servis',
      vehicle: 'Véhicule',
      // Revenus par heure
      revenuePerHourTitle: 'Revenus par heure (rentabilité)',
      revenuePerHourCaption: 'Rentabilité des services classée par revenus horaires',
      duration: 'Durée',
      revPerHour: '$/heure',
      // Acquisition de clients
      customerAcquisitionTitle: 'Nouveaux vs clients fidèles',
      newCustomers: 'Nouveaux',
      returningCustomers: 'Fidèles',
      // Absences & intervalle de visites
      noShows: 'Absences',
      avgDaysBetweenVisits: 'Intervalle moyen entre visites',
      // Divers
      noData: 'Aucune donnée disponible',
      actualPrices: 'Prix réels facturés',
      priceNote: 'Optionnel — laissez vide pour utiliser les estimations dans les rapports'
    },
    createAppointment: {
      title: 'Nouveau rendez-vous',
      step1: 'Client',
      step2: 'Véhicule',
      step3: 'Services',
      step4: 'Date et heure',
      step5: 'Confirmation',
      searchCustomer: 'Rechercher un client',
      searchPlaceholder: 'Nom, téléphone ou courriel...',
      noResults: 'Aucun client trouvé',
      newCustomer: 'Nouveau client',
      changeCustomer: 'Changer',
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      phone: 'Téléphone',
      email: 'Courriel',
      optional: 'optionnel',
      createCustomer: 'Créer le client',
      requiredFields: 'Le prénom, le nom et le téléphone sont requis',
      duplicatePhone: 'Un client avec ce numéro existe déjà. Sélectionnez-le ci-dessous.',
      errorCreating: 'Échec de la création',
      savedVehicles: 'Véhicules enregistrés',
      noVehicles: 'Aucun véhicule — ajoutez-en un ci-dessous',
      addVehicle: 'Ajouter un véhicule',
      skipVehicle: 'Passer (aucun véhicule)',
      servicesSelected: 'services sélectionnés',
      bookNow: 'Réserver maintenant',
      allowPast: 'Permettre les dates passées',
      customer: 'Client',
      servicesLabel: 'Services',
      dateTime: 'Date et heure',
      at: 'à',
      vehicleLabel: 'Véhicule',
      adminOptions: 'Options administrateur',
      status: 'Statut initial',
      sendNotification: 'Envoyer une notification au client',
      skipDeposit: 'Ne pas exiger de dépôt',
      overbook: 'Forcer la réservation (surcharge)',
      adminNotes: 'Notes internes',
      adminNotesPlaceholder: 'Notes internes (non visibles par le client)...',
      createAppointment: 'Créer le rendez-vous'
    },
    search: {
      placeholder: 'Rechercher par nom, t\u00e9l\u00e9phone, courriel\u2026',
      results: '{count} r\u00e9sultats',
      noResults: 'Aucun r\u00e9sultat trouv\u00e9',
      showing: '{from}\u2013{to} sur {total}',
      prev: '\u2039 Pr\u00e9c\u00e9dent',
      next: 'Suivant \u203A',
      rowsPerPage: 'Lignes\u00A0:',
      filters: 'Filtres',
      clearAll: 'Tout effacer',
      allStatuses: 'Tous les statuts',
      allServices: 'Tous les services',
      vehiclePlaceholder: 'Marque, mod\u00e8le, ann\u00e9e\u2026',
      dateFrom: 'Du',
      dateTo: 'Au'
    },
    recentActivity: 'Activit\u00e9 R\u00e9cente',
    latestAppts: 'DERNIERS RENDEZ-VOUS',
    recentReviews: 'AVIS RÉCENTS',
    newMessages: 'NOUVEAUX MESSAGES',
    noNewMessages: 'Aucun nouveau message',
    allAppointments: 'Tous les Rendez-vous',
    tableHeaders: {
      customer: 'Client',
      service: 'Service',
      vehicle: 'Véhicule',
      date: 'Date',
      time: 'Heure',
      status: 'Statut',
      actions: 'Actions'
    },
    viewNotes: 'Voir Notes',
    customerReviews: 'Avis Clients',
    total: 'total',
    avg: 'moy.',
    noReviews: 'Aucun avis pour le moment',
    contactMessages: 'Messages de Contact',
    newBadge: 'NOUVEAU',
    markRead: 'Marquer comme Lu',
    markResponded: 'Marquer comme Répondu',
    reply: 'Répondre',
    sendReply: 'Envoyer la Réponse',
    sending: 'Envoi...',
    replySuccess: 'Réponse envoyée avec succès',
    replyFailed: 'Échec de l\'envoi de la réponse',
    replyPlaceholder: 'Tapez votre réponse...',
    viewThread: 'Voir le Fil',
    hideThread: 'Masquer le Fil',
    adminReply: 'Réponse Admin',
    originalMessage: 'Message Original',
    noMessages: 'Aucun message pour le moment',
    attachImages: 'Joindre des images',
    attachHint: 'Max 3 images, 5 Mo chacune',
    allCustomers: 'Tous les Clients',
    customerHeaders: {
      name: 'Nom',
      email: 'Courriel',
      phone: 'Téléphone',
      appointments: 'Rendez-vous',
      lastVisit: 'Dernière Visite'
    },
    na: 'N/D',
    never: 'Jamais',
    errorUpdate: 'Erreur lors de la mise à jour du rendez-vous',
    errorMessage: 'Erreur lors de la mise à jour du message',
    settings: {
      title: 'Paramètres de l\'Application',
      googleApiKey: 'Clé API Google Places',
      googlePlaceId: 'ID du Lieu Google',
      mechanicsCount: 'Nombre de Mécaniciens',
      slotInterval: 'Intervalle des Créneaux (minutes)',
      save: 'Sauvegarder les Paramètres',
      saving: 'Sauvegarde...',
      saveSuccess: 'Paramètres sauvegardés avec succès',
      saveError: 'Échec de la sauvegarde des paramètres',
      testGoogle: 'Tester la Connexion Google',
      testing: 'Test en cours...',
      testSuccess: 'Connexion Google Reviews réussie!',
      testFail: 'Échec de la connexion Google Reviews. Vérifiez votre clé API et l\'ID du lieu.',
      googleSection: 'Intégration Google Reviews',
      schedulingSection: 'Planification',
      notificationSection: 'Notifications',
      twilioSection: 'Fournisseur SMS (Twilio)',
      twilioSid: 'Account SID',
      twilioAuthToken: 'Auth Token',
      twilioFromNumber: 'Numéro d\'envoi',
      googleHelpTitle: 'Comment obtenir les identifiants Google',
      twilioHelpTitle: 'Comment obtenir les identifiants Twilio',
      googleHelp: '1. Allez sur Google Cloud Console (console.cloud.google.com)\n2. Créez un projet ou sélectionnez un projet existant\n3. Activez l\'API "Places API" sous APIs et Services\n4. Allez dans Identifiants et créez une clé API\n5. Trouvez votre Place ID sur developers.google.com/maps/documentation/places/web-service/place-id',
      twilioHelp: '1. Inscrivez-vous sur twilio.com et vérifiez votre compte\n2. Depuis le tableau de bord Twilio Console, copiez votre Account SID et Auth Token\n3. Achetez un numéro de téléphone (ou utilisez le numéro d\'essai) — c\'est votre "Numéro d\'envoi"\n4. Entrez les identifiants ci-dessous et sauvegardez',
      emailSection: 'Notifications par Courriel',
      enableEmailNotifications: 'Activer les notifications par courriel aux clients',
      emailFromAddress: 'Adresse courriel d\'envoi',
      emailFromHint: 'L\'adresse courriel d\'envoi pour les notifications sortantes.',
      emailProvider: 'Fournisseur courriel',
      gmailApiHint: 'Utilise l\'API Gmail de Google via HTTPS. Requis pour Railway/hébergement cloud où les ports SMTP sont bloqués.',
      smtpHost: 'Hôte SMTP',
      smtpPort: 'Port SMTP',
      smtpUser: 'Utilisateur SMTP',
      smtpPassword: 'Mot de passe SMTP',
      smtpHint: 'Connexion SMTP directe. Fonctionne sur VPS/serveurs auto-hébergés.',
      gmailClientId: 'ID Client Gmail',
      gmailClientSecret: 'Secret Client Gmail',
      gmailRefreshToken: 'Jeton d\'actualisation Gmail',
      gmailTokenHint: 'Obtenez-le depuis Google OAuth Playground. Voir le guide ci-dessous.',
      gmailSetupGuide: 'Guide de configuration',
      testEmail: 'Envoyer un courriel test',
      testEmailSending: 'Envoi...',
      testEmailSuccess: 'Courriel test envoyé avec succès!',
      testEmailFailed: 'Échec de l\'envoi du courriel test',
      customerSmsSection: 'Notifications SMS aux Clients',
      enableCustomerSms: 'Activer les notifications SMS aux clients',
      customerSmsHint: 'Nécessite les identifiants Twilio configurés ci-dessus. Envoie uniquement aux clients avec un numéro de téléphone vérifié.',
      shopInfoSection: 'Informations du Commerce',
      shopName: 'Nom du Commerce',
      shopAddress: 'Adresse du Commerce',
      shopPhone: 'Téléphone du Commerce',
      shopTimezone: 'Fuseau Horaire',
      scheduleSection: 'Horaires d\'Ouverture',
      translationSection: 'Fournisseur de Traduction',
      translationProvider: 'Fournisseur',
      translationProviderNone: 'Aucun (manuel uniquement)',
      translationProviderDeepl: 'DeepL',
      translationProviderGoogle: 'Google Translate',
      translationApiKey: 'Clé API',
      translationHelp: 'Configurez un fournisseur de traduction pour traduire automatiquement les noms et descriptions de services entre le français et l\'anglais.',
      testTranslation: 'Tester la Traduction',
      testingTranslation: 'Test en cours...',
      translationSuccess: '\u2713 La traduction fonctionne',
      translationFailed: '\u00c9chec de la traduction',
      stripeSection: 'Paiements (Stripe)',
      enableDeposits: 'Activer les dépôts',
      enableDepositsHelp: 'Lorsqu\'activé, les clients doivent payer un dépôt lors de la réservation pour les services qui en exigent un.',
      stripeSecretKey: 'Clé secrète Stripe',
      stripeWebhookSecret: 'Secret du webhook Stripe',
      stripeHelpTitle: 'Comment configurer Stripe?',
      stripeHelp: '1. Créez un compte Stripe sur stripe.com\n2. Dans le Dashboard Stripe, allez à Développeurs > Clés API\n3. Copiez la clé secrète (sk_live_... ou sk_test_...)\n4. Créez un webhook pointant vers votre-domaine.com/api/payments/webhook\n5. Copiez le secret de signature du webhook (whsec_...)'
    },
    services: {
      title: 'Gérer les Services',
      addService: 'Ajouter un Service',
      editService: 'Modifier le Service',
      name: 'Nom du Service',
      description: 'Description',
      category: 'Catégorie',
      duration: 'Durée (min)',
      priceMin: 'Prix Min ($)',
      priceMax: 'Prix Max ($)',
      status: 'Statut',
      active: 'Actif',
      inactive: 'Inactif',
      toggleActive: 'Basculer Actif',
      confirmDelete: 'Êtes-vous sûr de vouloir désactiver ce service?',
      saveService: 'Sauvegarder le Service',
      saving: 'Sauvegarde...',
      saveError: 'Erreur lors de la sauvegarde du service',
      selectCategory: 'Sélectionner une catégorie...',
      addNewCategory: '+ Ajouter une nouvelle catégorie',
      newCategoryPlaceholder: 'Entrez la nouvelle catégorie...',
      icon: 'Icône',
      selectIcon: 'Sélectionner une icône pour ce service',
      nameFr: 'Nom du Service (FR)',
      nameEn: 'Nom du Service (EN)',
      descriptionFr: 'Description (FR)',
      descriptionEn: 'Description (EN)',
      categoryFr: 'Catégorie (FR)',
      categoryEn: 'Catégorie (EN)',
      langTabFr: 'Français',
      langTabEn: 'Anglais',
      autoTranslate: 'Traduction auto',
      translating: 'Traduction...',
      translateError: 'Échec de la traduction',
      bilingualRequired: 'Les noms en français et en anglais sont requis'
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Tout Marquer comme Lu',
      empty: 'Aucune notification',
      newAppointment: 'Nouveau Rendez-vous',
      unread: 'non lu(s)',
      toastClickHint: 'Cliquez pour voir le rendez-vous'
    },
    push: {
      enable: 'Activer les notifications push',
      enableShort: 'Activer Push',
      active: 'Notifications push actives',
      activeShort: 'Push',
      denied: 'Notifications push bloquées dans les paramètres du navigateur',
      blockedShort: 'Push bloqué'
    },
    notificationSettings: {
      title: 'Paramètres de Notification',
      enableSound: 'Activer le son de notification',
      enableSms: 'Activer les notifications SMS',
      adminPhone: 'Numéro de téléphone admin',
      adminPhonePlaceholder: '+1 514-000-0000'
    },
    schedule: {
      weeklyHours: 'Heures Hebdomadaires',
      open: 'Ouvert',
      saveHours: 'Sauvegarder les Heures',
      saveSuccess: 'Horaires sauvegardés avec succès',
      saveError: 'Échec de la sauvegarde des horaires',
      closures: 'Fermetures Planifiées',
      startDate: 'Date de Début',
      endDate: 'Date de Fin',
      reason: 'Raison',
      reasonPlaceholder: 'Congé, vacances...',
      addClosure: 'Ajouter'
    },
    promotions: {
      title: 'Gérer les Promotions',
      addPromo: 'Ajouter une Promotion',
      editPromo: 'Modifier la Promotion',
      titleEn: 'Titre (EN)',
      titleFr: 'Titre (FR)',
      bodyEn: 'Contenu (EN)',
      bodyFr: 'Contenu (FR)',
      ctaTextEn: 'Texte du Bouton (EN)',
      ctaTextFr: 'Texte du Bouton (FR)',
      ctaUrl: 'URL du Lien',
      placement: 'Emplacement',
      placements: {
        home_hero: 'Accueil Hero',
        home_inline: 'Accueil En Ligne',
        services_top: 'Haut des Services',
        booking_sidebar: 'Barre Latérale Réservation',
        sitewide_banner: 'Bannière Globale'
      },
      imageUrl: 'URL de l\'Image',
      bgColor: 'Couleur de Fond',
      txtColor: 'Couleur du Texte',
      priority: 'Priorité',
      startAt: 'Date de Début',
      endAt: 'Date de Fin',
      active: 'Actif',
      inactive: 'Inactif',
      always: 'Toujours',
      views: 'Vues',
      clicks: 'Clics',
      today: 'aujourd\'hui',
      total: 'total',
      savePromo: 'Sauvegarder la Promotion',
      saving: 'Sauvegarde...',
      saveError: 'Erreur lors de la sauvegarde de la promotion',
      translateError: 'Échec de la traduction',
      confirmDelete: 'Désactiver cette promotion?',
      preview: 'Aperçu',
      learnMore: 'En Savoir Plus'
    },
    export: {
      title: 'Exporter les Rendez-vous',
      startDate: 'Date de Début',
      endDate: 'Date de Fin',
      status: 'Statut',
      allStatuses: 'Tous',
      exportCsv: 'Exporter CSV',
      exporting: 'Exportation...'
    },
    marketing: {
      title: 'Contenu Marketing',
      description: 'Modifiez le texte marketing sur les pages client. Laissez vide pour utiliser les valeurs par défaut.',
      pages: { home: 'Accueil', services: 'Services', about: 'À Propos', contact: 'Contact', faq: 'FAQ', gallery: 'Galerie', book: 'Réservation', login: 'Connexion', register: 'Inscription' },
      en: 'Anglais',
      fr: 'Français',
      save: 'Sauvegarder',
      saving: 'Sauvegarde...',
      saveSuccess: 'Contenu marketing sauvegardé',
      saveError: 'Erreur de sauvegarde',
      revert: 'Réinitialiser',
      customized: 'Personnalisé',
      default: 'Par défaut'
    },
    campaigns: {
      title: 'Campagnes Courriel',
      newCampaign: 'Nouvelle Campagne',
      editCampaign: 'Modifier la Campagne',
      subjectEn: 'Sujet (EN)',
      subjectFr: 'Sujet (FR)',
      bodyEn: 'Contenu (EN)',
      bodyFr: 'Contenu (FR)',
      status: 'Statut',
      draft: 'Brouillon',
      scheduled: 'Planifiée',
      sending: 'En envoi',
      sent: 'Envoyée',
      failed: 'Échouée',
      recipients: 'Destinataires',
      sentCount: 'Envoyés',
      failedCount: 'Échoués',
      openedCount: 'Ouverts',
      saveDraft: 'Sauvegarder le Brouillon',
      sendTest: 'Envoyer un Test',
      sendNow: 'Envoyer Maintenant',
      schedule: 'Planifier',
      confirmSend: 'Envoyer cette campagne à tous les clients abonnés?',
      preview: 'Aperçu',
      delete: 'Supprimer',
      confirmDelete: 'Supprimer cette campagne brouillon?',
      testSent: 'Courriel test envoyé!',
      scheduledFor: 'Planifiée pour',
      noRecipients: 'Aucun destinataire éligible',
      noCampaigns: 'Aucune campagne pour le moment',
      recipientCount: 'Sera envoyé à {count} clients',
      created: 'Créée',
      autoTranslate: 'Traduction auto',
      translating: 'Traduction...',
      langTabEn: 'Anglais',
      langTabFr: 'Français',
      viewDetails: 'Voir les Détails',
      backToList: 'Retour aux Campagnes',
      paused: 'En pause',
      resume: 'Reprendre',
      quotaInfo: 'Quota quotidien : {sent}/{limit} envoyés ({remaining} restants)'
    },
    depositAmount: 'Montant du dépôt ($)',
    depositAmountHelp: 'Laissez vide pour ne pas exiger de dépôt',
    paymentStatus: 'Paiement',
    paymentPaid: 'Payé',
    paymentPending: 'En attente',
    paymentRefunded: 'Remboursé',
    paymentNone: 'Aucun',
    import: {
      title: 'Importer des Clients',
      description: 'Téléversez un export CSV QuickBooks pour importer des clients. Colonnes attendues : Prénom, Nom, Courriel, Téléphone.',
      preview: 'Aperçu de l\'importation',
      toImport: 'À importer',
      toSkip: 'Déjà existants',
      errorsCount: 'Erreurs',
      csvErrors: 'Erreurs CSV',
      confirmImport: 'Confirmer l\'importation',
      imported: 'Importés',
      skipped: 'Ignorés',
      sendOnboarding: 'Envoyer les courriels d\'accueil',
      onboardingHint: 'Envoyer les courriels de création de mot de passe à {count} clients importés',
      importAnother: 'Importer un autre fichier',
      name: 'Nom',
      phone: 'Téléphone'
    },
    customerProfile: {
      identity: 'Identité',
      appointmentsSection: 'Rendez-vous',
      vehiclesSection: 'Véhicules',
      reviewsSection: 'Avis',
      messagesSection: 'Messages',
      remindersSection: 'Rappels',
      contactInfo: 'Coordonnées',
      language: 'Langue',
      lastLogin: 'Dernière connexion',
      notifications: 'Préférences de notification',
      emailNotif: 'Courriel',
      marketing: 'Marketing',
      verified: 'Vérifié',
      notVerified: 'Non vérifié',
      customerSince: 'Client depuis',
      imported: 'Importé',
      totalAppts: 'Total RDV',
      upcoming: 'À venir',
      reviewCount: 'Avis',
      vehicleCount: 'Véhicules',
      lastAppt: 'Dernier rendez-vous complété',
      noAppointments: 'Aucun rendez-vous',
      noVehicles: 'Aucun véhicule',
      noReminders: 'Aucun rappel',
      plate: 'Plaque',
      color: 'Couleur',
      replies: 'réponses',
      reminderDate: 'Date du rappel',
      channels: 'Canaux',
      phone2: 'T\u00e9l\u00e9phone secondaire',
      mergeWith: 'Fusionner avec\u2026',
      editButton: 'Modifier',
      deleteButton: 'Supprimer',
      saveChanges: 'Enregistrer',
      firstName: 'Pr\u00e9nom',
      lastName: 'Nom',
      readOnly: 'lecture seule',
      addVehicle: 'Ajouter un v\u00e9hicule',
      editVehicle: 'Modifier le v\u00e9hicule',
      deleteVehicleConfirm: 'Supprimer ce v\u00e9hicule? Cette action est irr\u00e9versible.',
      vehicleRequired: 'La marque, le mod\u00e8le et l\'ann\u00e9e sont requis',
      vehicleVin: 'NIV',
      vehicleColor: 'Couleur'
    },
    merge: {
      mergeButton: 'Fusionner les clients s\u00e9lectionn\u00e9s',
      title: 'Fusionner les comptes clients',
      selectPrimary: 'S\u00e9lectionnez le compte \u00e0 conserver. Toutes les donn\u00e9es de l\u2019autre compte seront transf\u00e9r\u00e9es.',
      primary: 'Principal \u2014 conserve l\u2019identit\u00e9',
      secondary: 'Secondaire \u2014 sera d\u00e9sactiv\u00e9',
      warning: 'Cette action est irr\u00e9versible. Le compte secondaire sera d\u00e9finitivement d\u00e9sactiv\u00e9.',
      confirmWarning: 'Cette action est irr\u00e9versible. \u00cates-vous s\u00fbr?',
      confirm: 'Confirmer la fusion',
      cancel: 'Annuler',
      success: 'Comptes fusionn\u00e9s avec succ\u00e8s!',
      created: 'Cr\u00e9\u00e9',
      appointments: 'rendez-vous',
      vehicles: 'v\u00e9hicules',
      reviews: 'avis',
      messages: 'messages',
      reminders: 'rappels',
      consents: 'consentements',
      selectTwo: 'S\u00e9lectionnez exactement 2 clients \u00e0 fusionner',
      searchPlaceholder: 'Rechercher un client \u00e0 fusionner avec\u2026'
    },
    reminders: {
      title: 'Rappels d\'Entretien',
      allReminders: 'Tous les Rappels',
      serviceRules: 'Règles par Service',
      customer: 'Client',
      service: 'Service',
      reminderDate: 'Date du Rappel',
      channels: 'Canaux',
      status: 'Statut',
      actions: 'Actions',
      scheduled: 'Planifié',
      sent: 'Envoyé',
      failed: 'Échoué',
      cancelled: 'Annulé',
      allStatuses: 'Tous les statuts',
      noReminders: 'Aucun rappel planifié',
      reschedule: 'Replanifier',
      cancel: 'Annuler',
      confirmCancel: 'Annuler ce rappel?',
      cancelError: 'Erreur lors de l\'annulation',
      rescheduleError: 'Erreur lors de la replanification',
      newDate: 'Nouvelle date',
      saveReschedule: 'Sauvegarder',
      scheduleTitle: 'Compléter le Rendez-vous',
      scheduleReminder: 'Planifier un rappel d\'entretien',
      interval: 'Rappeler dans',
      months: 'mois',
      customDate: 'Date personnalisée',
      willSend: 'Le rappel sera envoyé le',
      skipReminder: 'Compléter sans rappel',
      completeAndSchedule: 'Compléter et Planifier',
      completeOnly: 'Compléter',
      enabled: 'Activé',
      disabled: 'Désactivé',
      edit: 'Modifier',
      intervals: 'Intervalles',
      saveRule: 'Sauvegarder la Règle',
      saveRuleError: 'Erreur lors de la sauvegarde',
      rulesDescription: 'Configurez les intervalles de rappel par défaut pour chaque service. Ces valeurs sont suggérées lors de la complétion des rendez-vous.',
      noRules: 'Aucune règle configurée.'
    }
  },

  forgotPassword: {
    title: 'Réinitialiser le mot de passe',
    subtitle: 'Entrez votre courriel pour recevoir un lien de réinitialisation',
    emailLabel: 'Adresse Courriel',
    button: 'Envoyer le lien',
    sending: 'Envoi...',
    backToLogin: '\u2190 Retour à la connexion',
    successTitle: 'Vérifiez votre courriel',
    successMessage: 'Si un compte existe avec ce courriel, nous avons envoyé un lien de réinitialisation. Veuillez vérifier votre boîte de réception (et le dossier spam).',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    verifyFirst: 'Vérifiez votre courriel d\'abord',
    verifyMessage: 'Votre courriel n\'est pas encore vérifié. Nous avons envoyé un nouveau code de vérification. Veuillez vous connecter et vérifier votre courriel avant de réinitialiser votre mot de passe.'
  },

  setPassword: {
    title: 'Créez votre mot de passe',
    welcome: 'Bienvenue, {name}! Créez un mot de passe pour accéder à votre compte.',
    passwordLabel: 'Mot de passe',
    confirmLabel: 'Confirmer le mot de passe',
    marketingLabel: "J'accepte de recevoir des offres, promotions et conseils par courriel de la part de Mécanique Auto CJPA. Je peux retirer mon consentement à tout moment.",
    submit: 'Créer le mot de passe et se connecter',
    setting: 'Création en cours...',
    invalidTitle: 'Lien invalide',
    invalidLink: 'Paramètres de lien invalides ou manquants.',
    expired: 'Ce lien a expiré ou est invalide.',
    tooShort: 'Le mot de passe doit contenir au moins 6 caractères.',
    mismatch: 'Les mots de passe ne correspondent pas.',
    error: 'Échec de la création du mot de passe. Le lien a peut-être expiré.'
  },

  emailVerify: {
    title: 'Vérifiez Votre Courriel',
    subtitle: 'Nous avons envoyé un code à 6 chiffres à',
    enterCode: 'Code de Vérification',
    verify: 'Vérifier',
    verifying: 'Vérification...',
    resend: 'Renvoyer le Code',
    cooldown: 'Renvoyer dans {seconds}s',
    success: 'Courriel vérifié avec succès!',
    verifyError: 'Échec de la vérification',
    sendError: 'Échec de l\'envoi du code de vérification',
    checkSpam: 'Vérifiez votre dossier spam si vous ne voyez pas le courriel.',
    signOut: 'Se déconnecter'
  },

  phoneVerify: {
    title: 'Vérifier le Numéro de Téléphone',
    enterPhone: 'Entrez votre numéro de téléphone pour recevoir un code de vérification par SMS.',
    phoneLabel: 'Numéro de Téléphone',
    sendCode: 'Envoyer le Code',
    sending: 'Envoi...',
    sendError: 'Échec de l\'envoi du code de vérification',
    enterCode: 'Entrez le code à 6 chiffres envoyé au',
    codeLabel: 'Code de Vérification',
    verify: 'Vérifier',
    verifying: 'Vérification...',
    verifyError: 'Échec de la vérification',
    success: 'Téléphone vérifié avec succès!'
  },

  seo: {
    _locale: 'fr_CA',
    home: {
      title: 'Mécanique Auto CJPA | Garage Automobile Montréal-Nord | 514-327-2107',
      description: 'Garage automobile de confiance à Montréal-Nord. Changement d\'huile, freins, diagnostic moteur, transmission et plus. Techniciens certifiés ASE. Appelez le 514-327-2107.',
      path: '/fr',
      routeName: 'home'
    },
    services: {
      title: 'Services Automobiles | Mécanique Auto CJPA Montréal-Nord',
      description: 'Découvrez nos services : changement d\'huile, freins, diagnostic moteur, transmission, alignement des roues. Prix transparents et techniciens certifiés à Montréal-Nord.',
      path: '/fr/services',
      routeName: 'services'
    },
    about: {
      title: 'À Propos | Mécanique Auto CJPA Montréal-Nord',
      description: 'Fondé en 2016 à Montréal-Nord, Mécanique Auto CJPA offre un service automobile de qualité avec intégrité et expertise. Découvrez notre histoire et nos valeurs.',
      path: '/fr/a-propos',
      routeName: 'about'
    },
    contact: {
      title: 'Contactez-nous | Mécanique Auto CJPA Montréal-Nord',
      description: 'Contactez Mécanique Auto CJPA au 514-327-2107 ou visitez-nous au 10011 Av. de Rome, Montréal-Nord. Ouvert lun-ven 9h-18h.',
      path: '/fr/contact',
      routeName: 'contact'
    },
    faq: {
      title: 'FAQ | Mécanique Auto CJPA Montréal-Nord',
      description: 'Réponses aux questions fréquentes sur nos services automobiles, la réservation, les tarifs et les garanties. Mécanique Auto CJPA, Montréal-Nord.',
      path: '/fr/faq',
      routeName: 'faq'
    },
    gallery: {
      title: 'Galerie | Mécanique Auto CJPA Montréal-Nord',
      description: 'Galerie photo de nos travaux de réparation et d\'entretien automobile. Mécanique Auto CJPA, Montréal-Nord.',
      path: '/fr/galerie',
      routeName: 'gallery'
    },
    privacy: {
      title: 'Politique de Confidentialité | Mécanique Auto CJPA',
      description: 'Politique de confidentialité de Mécanique Auto CJPA. Conforme à la Loi 25 du Québec et à la LPRPDE.',
      path: '/fr/confidentialite',
      routeName: 'privacy'
    },
    terms: {
      title: 'Conditions d\'Utilisation | Mécanique Auto CJPA',
      description: 'Conditions d\'utilisation de Mécanique Auto CJPA. Garanties, tarification et droits du consommateur conformes aux lois du Québec.',
      path: '/fr/conditions',
      routeName: 'terms'
    },
    book: {
      title: 'Prendre Rendez-vous | Mécanique Auto CJPA Montréal-Nord',
      description: 'Réservez votre rendez-vous en ligne chez Mécanique Auto CJPA. Choisissez votre service, date et heure. Montréal-Nord.',
      path: '/fr/rendez-vous',
      routeName: 'book'
    },
    login: {
      title: 'Connexion | Mécanique Auto CJPA',
      description: 'Connectez-vous à votre compte Mécanique Auto CJPA.',
      path: '/fr/connexion',
      routeName: 'login',
      noindex: true
    },
    register: {
      title: 'Créer un Compte | Mécanique Auto CJPA',
      description: 'Créez votre compte Mécanique Auto CJPA pour réserver des rendez-vous.',
      path: '/fr/inscription',
      routeName: 'register',
      noindex: true
    },
    dashboard: {
      title: 'Mon Compte | Mécanique Auto CJPA',
      description: 'Gérez vos rendez-vous et votre compte Mécanique Auto CJPA.',
      path: '/fr/tableau-de-bord',
      routeName: 'dashboard',
      noindex: true
    },
    admin: {
      title: 'Administration | Mécanique Auto CJPA',
      description: 'Tableau de bord administrateur Mécanique Auto CJPA.',
      path: '/fr/admin',
      routeName: 'admin',
      noindex: true
    }
  },

  images: {
    hero: 'Intérieur du garage Mécanique Auto CJPA — atelier de réparation automobile professionnel à Montréal-Nord',
    aboutShop: 'Intérieur de l\'atelier Mécanique Auto CJPA — installation de réparation automobile propre et bien équipée à Montréal-Nord',
    aboutTeam: 'Mécaniciens certifiés CJPA travaillant sur un moteur de véhicule à Montréal-Nord',
    servicesHeader: 'Mécanicien professionnel effectuant un diagnostic véhicule chez Mécanique Auto CJPA',
    gallery1: 'Réparation et diagnostic moteur chez Mécanique Auto CJPA',
    gallery2: 'Service professionnel de remplacement de disques et plaquettes de frein',
    gallery3: 'Service de changement d\'huile — vidange de l\'huile moteur usagée',
    gallery4: 'Diagnostic OBD-II sur le système informatique du véhicule',
    gallery5: 'Réparation et entretien de boîte de vitesses',
    gallery6: 'Service d\'alignement de roues par laser de précision',
  },

  common: {
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    save: 'Sauvegarder',
    edit: 'Modifier',
    delete: 'Supprimer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    submit: 'Soumettre',
    or: 'ou'
  }
};
